// LMS transactional email via the send-email Edge Function and Resend.
// The Edge Function sends only to the signed-in user's account address; the
// browser never supplies a recipient or talks to Resend directly.
import { supabase } from '../integrations/supabase/client';

type EmailTemplate =
  | { template: 'enrollment'; toName: string; courseTitle: string; ref: string; verified?: boolean }
  | { template: 'completion'; toName: string; courseTitle: string; certCode: string };

async function invoke(payload: EmailTemplate) {
  try {
    const { data, error } = await supabase.functions.invoke('send-email', { body: payload });
    if (error) {
      console.warn('[notify] Email could not be sent:', error.message);
      return { sent: false as const, reason: 'send-failed' as const };
    }
    if (!data?.ok) {
      console.warn('[notify] Email could not be sent:', data?.message ?? 'unknown error');
      return { sent: false as const, reason: 'send-failed' as const };
    }
    return { sent: true as const };
  } catch (error) {
    console.warn('[notify] Email request failed:', error);
    return { sent: false as const, reason: 'send-failed' as const };
  }
}

export function sendEnrollmentEmail(args: {
  toName: string;
  courseTitle: string;
  ref: string;
  verified?: boolean;
}) {
  return invoke({
    template: 'enrollment',
    toName: args.toName,
    courseTitle: args.courseTitle,
    ref: args.ref,
    verified: args.verified,
  });
}

export function sendCompletionEmail(args: {
  toName: string;
  courseTitle: string;
  certCode: string;
}) {
  return invoke({
    template: 'completion',
    toName: args.toName,
    courseTitle: args.courseTitle,
    certCode: args.certCode,
  });
}
